import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type AddDefaultsMaterials = ClientInferResponseBody<
  typeof contract.materials.addDefaultsMaterials,
  200
>;

export const addDefaultsMaterials = async (): Promise<AddDefaultsMaterials> => {
  const response = await api.materials.addDefaultsMaterials.mutation({
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to add default materials", response.status, response.body);
};
